// Configured-client registry (Wave 2 · E5, ARCFE-805).
//
// `createScribeHttpClients` is a pure factory — the CONFIGURED instances
// (env-derived base URLs, auth/tracing interceptors, retry machinery) are
// app-wired (G1/F5: packages never read env or the store). This registry is
// the hand-off: app wiring builds the clients once and `set`s them here;
// domain `data/api` layers `get` them instead of each domain carrying an
// injected `http` config field.
//
// Per-app by construction: each app's wiring sets ITS OWN instances (web:
// `src/utils/scribeHTTP.ts`; the widget's ring-③ wiring will set widget-built
// clients). Scope boundary: the scribe client family, and the transcription
// client the speaker transport reads. Domain-specific service clients (e.g.
// coding's clinical-coding client with its SCC-JWT interceptor) stay per-domain seams.

import type { AxiosInstance } from 'axios';

import type { ScribeHttpClients } from './types';

let clients: ScribeHttpClients | null = null;

export const setScribeHttpClients = (next: ScribeHttpClients): void => {
  clients = next;
};

/** Fail loudly on unconfigured use — never silently degrade. */
export const getScribeHttpClients = (): ScribeHttpClients => {
  if (!clients) {
    throw new Error(
      '[@heidi/api] scribe HTTP clients not configured — app wiring must call ' +
        'setScribeHttpClients(...) at bootstrap (web: src/utils/scribeHTTP.ts). ' +
        'Tests exercising real domain data/api fns must set a double first.'
    );
  }
  return clients;
};

let t11nHttpClient: AxiosInstance | null = null;

export const setT11nHttpClient = (client: AxiosInstance): void => {
  t11nHttpClient = client;
};

/** Fail loudly on unconfigured use — never silently degrade. */
export const getT11nHttpClient = (): AxiosInstance => {
  if (!t11nHttpClient) {
    throw new Error(
      '[@heidi/api] t11n HTTP client not configured — app wiring must call ' +
        'setT11nHttpClient(...) at bootstrap (web: src/lib/SessionRecordingProvider/t11nClient.ts). ' +
        'Tests exercising real domain data/api fns must set a double first.'
    );
  }
  return t11nHttpClient;
};
